import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_DENIAL_REASONS_LIST } from "../services/get-denial-reasons-list";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_DENIAL_REASONS_REFERENCE_DATA } from "../services/get-reference-data";
import { GET_DENIAL_REASONS_AUDIT_GROUP_LIST } from "../services/get-audit-group-list";
import { GET_DENIAL_REASONS_BY_ID } from "../services/get-denial-reasons-by-id";
import { GET_DENIAL_REASONS_LINKED_DATA } from "../services/get-denial-reasons-linked-data";
import { format } from "date-fns";
import { GET_TARGET_DATA_LOOKUPS } from "../../../external-audit/services/get-target-data-lookups";
export const TOGGLE_DENIAL_REASONS_LIST_ACTION_POPOVER =
  "TOGGLE_DENIAL_REASONS_LIST_ACTION_POPOVER";
export const TOGGLE_ADD_DENIAL_REASONS_POPUP = "TOGGLE_ADD_DENIAL_REASONS_POPUP";
export const SET_DENIAL_REASONS_FORM_DATA = "SET_DENIAL_REASONS_FORM_DATA";
export const FILTER_TASK_LEVEL_BY_WORKFLOW = "FILTER_TASK_LEVEL_BY_WORKFLOW";
export const FILTER_CATEGORIES_BY_WORKFLOW = "FILTER_CATEGORIES_BY_WORKFLOW";
export const SET_DENIAL_REASONS_END_DATE="SET_DENIAL_REASONS_END_DATE";
export const FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW =
  "FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW";
export const SET_DENIAL_REASONS_DATAGRID_FILTER =
  "SET_DENIAL_REASONS_DATAGRID_FILTER";
export const TOGGLE_DENIAL_REASONS_WARNING_POPUP =
  "TOGGLE_DENIAL_REASONS_WARNING_POPUP";
export const RESET_DENIAL_REASONS_POPUP_VALIDATION =
  "RESET_DENIAL_REASONS_POPUP_VALIDATION";
export const SET_DENIAL_REASON_AFFECTING_FIELDS_CHANGE_OBJECT =
  "SET_DENIAL_REASON_AFFECTING_FIELDS_CHANGE_OBJECT";
export const ENABLE_DISABLE_DENIAL_REASONS_FIELDS =
  "ENABLE_DISABLE_DENIAL_REASONS_FIELDS";
export const defaultDenialReasonsFormData = {
  denialReasonId: 0,
  denialReasonName: "",
  displayName: null,
  description: null,
  categoryId: null,
  categoryName: null,
  effectiveDate: new Date(),
  termDate: null,
  activeInd: true,
  curatedInd: false,
  createdBy: "",
  updatedBy: "",
  createDate: null,
  updateDate: null,
  eaRequesterId: null,
  selectedAuditGroupIds: []

};
const initialDenialReasonsLinkedData = {
  denialReasonAttachedAudit: [],
};
const initialState = {
  isLoading: false,
  hasAllAuditGroupAccess: false,
  denialReasonsList: [],
  taskLevelListByWorkflow: {},
  attachLevelEnums: {},
  workflowModuleTypeEnums: {},
  assignedToEnums: {},
  taskLevelList: [],
  denialReasonsFormData: { ...defaultDenialReasonsFormData },
  initialDenialReasonsFormData: { ...defaultDenialReasonsFormData },
  denialReasonsDataGridFilter: [],
  denialReasonsLinkedData: initialDenialReasonsLinkedData,
  userTaskAffectingFieldsChangeTrackerObject: {},
  isModuleTypeDisabled: false,
  isLevelValueDisabled: false,
  auditGroupDataSourceList: [],
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_DENIAL_REASONS_LIST_ACTION_POPOVER:      
    case SET_DENIAL_REASONS_DATAGRID_FILTER:
    case TOGGLE_ADD_DENIAL_REASONS_POPUP:
    case TOGGLE_DENIAL_REASONS_WARNING_POPUP:
    case RESET_DENIAL_REASONS_POPUP_VALIDATION:
   case SET_DENIAL_REASONS_END_DATE:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_DENIAL_REASONS_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const denialReasonsFormData = newState.denialReasonsFormData
          ? newState.denialReasonsFormData
          : {};
        for (let prop in action.data.denialReasonsFormData) {
          denialReasonsFormData[prop] = action.data.denialReasonsFormData[prop];
          if (
            prop == "selectedAuditGroupIds" &&
            action.data.denialReasonsFormData.selectedAuditGroupIds.length == 0
          ) {
            denialReasonsFormData.selectedAuditGroupIds = state.auditGroupDataSourceList?.map(
              (x) => x.auditGroupId
            );
          }
        }
        const initialDenialReasonsFormData = newState.initialDenialReasonsFormData
          ? newState.initialDenialReasonsFormData
          : {};
        for (let prop in action.data.initialDenialReasonsFormData) {
          initialDenialReasonsFormData[prop] =
            action.data.initialDenialReasonsFormData[prop];
        }
        newState = {
          ...newState,
          denialReasonsFormData,
          initialDenialReasonsFormData,
        };
      }
      return newState;
    case FILTER_TASK_LEVEL_BY_WORKFLOW:
      return { ...state, taskLevelList: action.levelList };
    case FILTER_CATEGORIES_BY_WORKFLOW:
      return { ...state, filteredCategoryList: action.filteredCategoryList };
    case FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW:
      return {
        ...state,
        assignedToUserTypeList: action.assignedToUserTypeList,
      };
    case SET_DENIAL_REASON_AFFECTING_FIELDS_CHANGE_OBJECT:
      return {
        ...state,
        ...action.data,
      };
    case ENABLE_DISABLE_DENIAL_REASONS_FIELDS:
      return { ...state, ...action.data };
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_DENIAL_REASONS_LIST)(action)) {
        return { ...state, denialReasonsList: [] };
      }
      if (isAsyncComplete(GET_DENIAL_REASONS_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          denialReasonsList: response.denialReasonsList,
          hasAllAuditGroupAccess: response.hasAllAuditGroupAccess,
        };
      }
      if (isAsyncOperation(GET_DENIAL_REASONS_REFERENCE_DATA)(action)) {
        return {
          ...state,
          taskLevelListByWorkflow: {},
          assignedToEnums: {},
          workflowModuleTypeEnums: {},
          attachLevelEnums: {},
          assignedToUserTypeDataSource: [],
          activeCategoryList: [],
          activeUserList: [],
        };
      }
      if (isAsyncComplete(GET_DENIAL_REASONS_REFERENCE_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          taskLevelListByWorkflow: response?.attachLevelList,
          assignedToEnums: response?.assignedToEnums[0],
          workflowModuleTypeEnums: response?.workflowModuleTypeEnums[0],
          attachLevelEnums: response?.attachLevelEnums[0],
          assignedToUserTypeDataSource: response?.assignedToTypeList,
          activeCategoryList: response?.activeCategoryList,
          activeUserList: response?.activeUserList,
          requesterList:response?.requesterList
        };
      }
      if (isAsyncOperation(GET_DENIAL_REASONS_AUDIT_GROUP_LIST)(action)) {
        return {
          ...state,
          auditGroupDataSourceList: [],
        };
      }
      if (isAsyncComplete(GET_DENIAL_REASONS_AUDIT_GROUP_LIST)(action)) {
        const response = action.response;
        defaultDenialReasonsFormData.selectedAuditGroupIds=response?.list.map
        ((x)=>x.auditGroupId
        );
        return {
          ...state,
          auditGroupDataSourceList: response?.list,
        };
      }
      if (isAsyncOperation(GET_DENIAL_REASONS_BY_ID)(action)) {
        return {
          ...state,
          denialReasonsItemFromDB: {},
        };
      }
      if (isAsyncComplete(GET_DENIAL_REASONS_BY_ID)(action)) {
        const response = action.response;
        return {
          ...state,
          denialReasonsItemFromDB: response,
        };
      }
      if (isAsyncOperation(GET_DENIAL_REASONS_LINKED_DATA)(action)) {
        return {
          ...state,
          denialReasonsLinkedData: initialDenialReasonsLinkedData,
        };
      }
      if (isAsyncComplete(GET_DENIAL_REASONS_LINKED_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          denialReasonsLinkedData: response,
        };
      }
      return state;
    default:
      return state;
  }
}

export const formatDenialReasonsObjectToDisplay = (
  denialReasonsFormData,
  auditGroupDataSource
) => {
  if (!denialReasonsFormData) return {};
  if (denialReasonsFormData.selectedAuditGroupIds?.length <= 0) {
    denialReasonsFormData.selectedAuditGroupIds = auditGroupDataSource.map(
      (x) => x.auditGroupId
    );
  }
  return denialReasonsFormData;
};

export const formatDenialReasonsObjectToSave = (
  denialReasonsFormData,
  auditGroupDataSource,
  assignedToEnums,
  workflowModuleTypeEnums,
  hasAllAuditGroupAccess
) => {
  denialReasonsFormData = cloneDeep(denialReasonsFormData);
  if (denialReasonsFormData.isDenialReasonsAssignedToExternalUser) {
    denialReasonsFormData.assignedToUserTypeValue = assignedToEnums.externalUser;
  }
  if (
    denialReasonsFormData.assignedToUserTypeValue !==
    assignedToEnums.designatedMdauditUser &&
    denialReasonsFormData.assignedToUserTypeValue !==
    assignedToEnums.externalUser
  ) {
    denialReasonsFormData.assignedToUserId = null;
  }
  const auditGroupIdList = auditGroupDataSource.map((x) => x.auditGroupId);
  if (
    denialReasonsFormData.selectedAuditGroupIds?.length ===
      auditGroupIdList?.length &&
    isEqual(
      denialReasonsFormData.selectedAuditGroupIds.slice(0).sort(),
      auditGroupIdList.slice(0).sort()
    ) &&
    hasAllAuditGroupAccess
  ) {
    denialReasonsFormData.selectedAuditGroupIds = null;
  }  
  denialReasonsFormData.effectiveDate = format(
    new Date(denialReasonsFormData.effectiveDate),
    "MM/DD/YYYY"
  );
  if (denialReasonsFormData.termDate)
    denialReasonsFormData.termDate = format(
      new Date(denialReasonsFormData.termDate),
      "MM/DD/YYYY"
    );
  delete denialReasonsFormData.createDate;
  delete denialReasonsFormData.updateDate;
  return denialReasonsFormData;
};
